import { getRuntimeEnv } from '../../helpers/runtimeEnv';
import { RuntimeEnv } from '../../helpers/RuntimeEnvEnum';

const __DEV__ = getRuntimeEnv() !== RuntimeEnv.Prod;

export const consoleLog = (...args: any[]) => {
  if (!__DEV__) {
    return;
  }
  // eslint-disable-next-line no-console
  console.log(...args);
};
export const consoleError = (...args: any[]) => {
  if (!__DEV__) {
    return;
  }
  // eslint-disable-next-line no-console
  console.error(...args);
};
export const consoleTable = (...args: any[]) => {
  if (!__DEV__) {
    return;
  }
  // eslint-disable-next-line no-console
  console.table(...args);
};
